import React from 'react';
import { observer } from 'mobx-react';
import { Row } from 'antd';
import { Catcher, FilterToolbar, FilterUrlManager, rowGutter } from '../../';
import { FinancesActiveCard, FinancesInfoCard } from './';
import { FinancesRevenuesCosts } from './FinancesRevenuesCosts';
import { useDashboardFilterParamsFinance } from '../../../hooks';
import { cleanDashboardRelationSelectAndStore, setDashboardForcedUpdateTime } from '../../../middleware';
import Styles from '../m_dashboarStyles.less';

export const FinancesHeader: React.FC = observer(() => {
    const filterParams = useDashboardFilterParamsFinance();

    return (
        <Catcher>
            <FilterUrlManager
                cleanStore={cleanDashboardRelationSelectAndStore}
                filterParams={filterParams}
                setForcedUpdateTime={setDashboardForcedUpdateTime}
            />

            <FilterToolbar
                filterParams={filterParams}
                onChange={setDashboardForcedUpdateTime}
                className={Styles.filterToolbar}
            />
            <div className={Styles.cardsPanel}>
                <Row gutter={rowGutter.card} className={Styles.cardsRow} justify="space-between">
                    <FinancesRevenuesCosts />
                    <FinancesInfoCard />
                    <FinancesActiveCard />
                </Row>
            </div>
        </Catcher>
    );
});
